import React from "react";
import classNames from "classnames";

export default function Spinner(props) {
    const { classes = {} } = props;
    return (
        <div className={classNames(classes.spinnerAddOn, "spinner")}>
            <svg className="circular">
                <circle className="path" cx="20" cy="20" r="15" />
            </svg>
        </div>
    );
}
